import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import CMS from "@/utils/cms.ts";
import st from "@/styles/PromoPages.module.scss"
import clsx from "clsx";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import React, { useState} from "react";
import NoImgContainer from "@/ui/NoImgContainer.tsx";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";
import {useLocation, useNavigate } from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
// import SettingsIcon from "@/svg/SettingsIcon.tsx";
// import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import LoadIcon from "@/svg/LoadIcon.tsx";
import Button from "@/ui/Button.tsx";
import LazyImage from "@/ui/LazyImage.tsx";
import {items_on_page} from "@/utils/constants.ts";


const PromotionsPage = () => {
    const promos_test = [
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
        ...CMS.getCabinetOffers(),
    ]
    const promos = import.meta.env.MODE === 'development' ? promos_test : CMS.getCabinetOffers();
    const {t, i18n} = useTranslation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false)
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")

    const get_param_as_obj = () => {
        const queryParams = new URLSearchParams(location.search);
        const paramsObject:any = {};
        
        queryParams.forEach((value, key) => {
            paramsObject[key] = Number(value);
        });
        
        return paramsObject
    }
    
    const paginated_proms = () => {
        
        const paramsObject:any = get_param_as_obj()
        
        return promos.slice(paramsObject.offset, paramsObject.limit)
        
    }
    
    
    const onMore = () => {
        setLoading(true)
        
        let timeout = setTimeout(() => {
            
            if(debug === "true") console.info("setInterval onMore")
            
            
            const currentParams:any = get_param_as_obj();
            const updatedQuery:any = {...currentParams, more: true}
            
            if(updatedQuery['moreCount']){
                updatedQuery['moreCount'] = Number(updatedQuery['moreCount']) + 1
            } else {
                updatedQuery['moreCount'] = 2
            }
            
            let updated_limit = Number(updatedQuery['limit']) || Number(items_on_page);
            updated_limit += Number(items_on_page);
            updatedQuery['limit'] = updated_limit;
            updatedQuery['page_number'] = updatedQuery['page_number'] ? Number(updatedQuery['page_number']) + 1 : 2
            
            
            const params = new URLSearchParams();
            
            Object.entries(updatedQuery).forEach(([key, value]) => {
                params.set(key, value as string)
            })
            navigate(location.pathname + `?${params.toString()}`)
            
            setLoading(false)
            
            clearTimeout(timeout)
        }, 1000)

    };
    
    
    const push_queries = (_e?: any, selectedItem?: any) => {
        
        const parsed: any = {};

        parsed["offset"] = (selectedItem * Number(items_on_page)) - Number(items_on_page);
        parsed["limit"] = selectedItem * Number(items_on_page);
        parsed["page_number"] = selectedItem;
        
        const params = new URLSearchParams();
        
        Object.entries(parsed).forEach(([key, value]) => {
            params.set(key, value as string)
        })
        navigate(location.pathname + `?${params.toString()}`)
        
    };
    

    return (
        <DashboardGenComponent
            header_type={"primary"}
            centered_content_expanded
            heading={
                <div className={st.heading}>
                    <h2>
                        {t("news&promo")}
                    </h2>
                    
                    {/*<button*/}
                    {/*    onClick={() => {*/}
                    {/*        eventEmitter.emit(CommonClass.ModalEvents.PromoSubscribe, true)*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <SettingsIcon />*/}
                    {/*</button>*/}
                </div>
            }
            header_content={
                <div className={st.header_content}>
                    <p>
                        {t("promo_page_inf")}
                    </p>
                </div>
            }
            column_center={
                <div className={st.column_center}>
                    {(Array.isArray(promos) && promos.length) ? (
                        <>
                            <div className={st.grid}>
                                {(Array.isArray(paginated_proms()) && paginated_proms().length) ? paginated_proms().map((prom: any, i: number) => {
                                    
                                    let pr = CMS.langAwareFilter(prom, (i18n.language as LocalLanguage))
                                    
                                    const {cabinet_visible} = pr
                                    
                                    return cabinet_visible && (
                                        <PromoGridItem key={`PromoGridItem ${i}`} pr={pr} order={i} first={i === 0}/>
                                    )
                                }) : null}
                            </div>
                            
                            <div className={clsx(st.pagination_container)}>
                                
                                {promos.length > Number(items_on_page) &&
                                    <Button
                                        className={clsx(st.button_load, loading && st.loading)}
                                        outlined
                                        type={'button'}
                                        onClick={onMore}
                                        disabled={get_param_as_obj().page_number == Math.ceil(promos.length / Number(items_on_page))}
                                    >
                                        <LoadIcon/> {t("load_more")}
                                    </Button>
                                }
                                
                                <Pagination
                                    key={'paginagion-' + get_param_as_obj().offset}
                                    count={Math.ceil(promos.length / Number(items_on_page))}
                                    renderItem={(item) => (
                                        <PaginationItem
                                            {...item}
                                        />
                                    )}
                                    page={get_param_as_obj().page_number ? get_param_as_obj().page_number : 1}
                                    defaultPage={get_param_as_obj().page_number ? get_param_as_obj().page_number : 1}
                                    onChange={push_queries}
                                    siblingCount={1}
                                    boundaryCount={1}
                                />
                            </div>
                        </>
                    ) : (
                        <strong className={st.no_promo}>{t("no_promotions")}</strong>
                    )}
                
                
                </div>
            }
        />
    )
}

interface GridItem {
    pr: any
    first: boolean
    order: number
}

const PromoGridItem: React.FC<GridItem> = (props) => {
    
    const {
        pr,
        first,
    } = props
    
    const {
        main_image,
        heading,
        api_id
    } = pr
    
    const navigate = useNavigate()
    const {t} = useTranslation()
    
    const nav_to_prom = () => {
        navigate(DashboardClass.dashboard_routes.Promo + "/" + api_id)
    }
    
    const prom_end_date = CommonClass.days_till_prom_end(pr)
    const is_prom_end_data = Boolean(typeof prom_end_date === "object" && Object.keys(prom_end_date))
    
    
    return (
        <div className={clsx(st.promo_grid_item, first && st.first)}>
            {(Array.isArray(main_image) && main_image.length) ? (
                <LazyImage
                    className={st.img}
                    src={CMS.getFilePath(main_image[0].path)}
                    alt={"prom"}
                    onClick={() => {
                        nav_to_prom()
                    }}
                />
            ) : (
                <NoImgContainer className={st.no_img}/>
            )}
            
            <div className={st.inf_container}>
                {heading && (
                    <h3
                        onClick={() => {
                            nav_to_prom()
                        }}
                    >
                        {heading}
                    </h3>
                )}
                
                <div
                    onClick={() => {
                        if (!is_prom_end_data) {
                            nav_to_prom()
                        }
                    }}
                    className={clsx(st.details, is_prom_end_data && st.prom)}
                >
                    
                    <div className={clsx(st.sides, st.right)}>
                        {is_prom_end_data ? (
                            <>
                                
                                {(prom_end_date.days <= 0 && prom_end_date.hours <= 0) ? (
                                    
                                    <span>
                                            {t("expired_promo")}
                                        </span>
                                    
                                    ) : (
                                    <>
                                        {Object.entries(prom_end_date).map((unity, i) => {
                                            let key = unity[0]
                                            let val = unity[1] as number | string;
                                            
                                            return (
                                                
                                                <div key={`is_prom_end_data_key ${i}`} className={st.time_unity}>
                                                    <strong>
                                                        {(typeof val !== undefined) && val}
                                                    </strong>
                                                    
                                                    <span>
                                                        {t(key)}
                                                    </span>
                                                </div>
                                            
                                            )
                                        })}
                                    </>
                                )}
                            </>

                        ) : (
                            <strong>
                                {t("more")}
                            </strong>
                        )}
                        
                    </div>
                    
                    <div className={clsx(st.sides, st.left)}>
                        <button
                            onClick={() => {
                                if(is_prom_end_data) {
                                    nav_to_prom()
                                }
                            }}
                            className={st.chevrone_button}
                        >
                            <ChevroneIcon/>
                        </button>
                    </div>
                
                </div>
            </div>
        
        </div>
    )
}

export default PromotionsPage